import React from "react";

export default function Account() {
  return (
    <div style={{
      color: "#54616c",
      margin : "1rem",
      padding : "10px",
    }}>
      <p style={{textAlign: "left"}}>
        Want to change your account email or password, or delete your account?
      </p>
    </div>
  );
}
